// @vendors
import { useTranslation } from 'react-i18next';

// @utils
import {
    returnText,
    returnTextWithNumber,
    returnTextWithSpam,
} from './utils/Utils';

const TermsAndCondition = ({ isOmboarding = false }) => {
    const { t } = useTranslation();
    const classSubtitle = "w-full text-[15px] text-[#494949] font-semibold flex";

    return (
        <div
            className={`w-full flex flex-col items-center bg-gray-100 gap-[30px]  ${isOmboarding ? 'py-[20px]' : 'h-[100vh] overflow-auto px-[20px] lg:px-[100px] py-[40px]'}`}
        >
            {!isOmboarding &&
                <>
                    <div className="flex items-center space-x-3 rtl:space-x-reverse" >
                        <span className="pl-6 xl:pl-4 text-textBrand text-center font-serif dark:text-dark-bgBrand text-[22px] xl:text-3xl font-bold leading-10 tracking-[5.50px] self-center whitespace-nowrap">
                            XERVIX
                        </span>
                    </div >
                    <h3 className='w-full text-[18px] text-[#03314B] font-semibold flex justify-center '>
                        {t("termsAdnConditions.title")}
                    </h3>
                </>
            }

            <div className='w-full flex flex-col gap-[20px]'>
                <h5 className={classSubtitle}>
                    1. {t("termsAdnConditions.numeral1.title")}
                </h5>
                {returnText(t("termsAdnConditions.numeral1.paragraph1"))}
                {returnText(t("termsAdnConditions.numeral1.paragraph2"))}
                {returnText(t("termsAdnConditions.numeral1.paragraph3"))}
            </div>

            <div className='w-full flex flex-col gap-[20px]'>
                <h5 className={classSubtitle}>
                    2. {t("termsAdnConditions.numeral2.title")}
                </h5>
                {returnTextWithSpam("2.1.", t("termsAdnConditions.numeral2.TParagraph1"), t("termsAdnConditions.numeral2.paragraph1"))}
                {returnTextWithSpam("2.2.", t("termsAdnConditions.numeral2.TParagraph2"), t("termsAdnConditions.numeral2.paragraph2"))}
                {returnTextWithSpam("2.3.", t("termsAdnConditions.numeral2.TParagraph3"), t("termsAdnConditions.numeral2.paragraph3"))}
                {returnTextWithSpam("2.4.", t("termsAdnConditions.numeral2.TParagraph4"), t("termsAdnConditions.numeral2.paragraph4"))}
                {returnTextWithSpam("2.5.", t("termsAdnConditions.numeral2.TParagraph5"), t("termsAdnConditions.numeral2.paragraph5"))}
                {returnTextWithSpam("2.6.", t("termsAdnConditions.numeral2.TParagraph6"), t("termsAdnConditions.numeral2.paragraph6"))}
                {returnText(t("termsAdnConditions.numeral2.paragraph7"))}
            </div>

            <div className='w-full flex flex-col gap-[20px]'>
                <h5 className={classSubtitle}>
                    3. {t("termsAdnConditions.numeral3.title")}
                </h5>
                {returnText(t("termsAdnConditions.numeral3.paragraph1"))}
            </div>

            <div className='w-full flex flex-col gap-[20px]'>
                <h5 className={classSubtitle}>
                    4. {t("termsAdnConditions.numeral4.title")}
                </h5>
                {returnText(t("termsAdnConditions.numeral4.paragraph1"))}
                {returnText(t("termsAdnConditions.numeral4.paragraph2"))}
                {returnText(t("termsAdnConditions.numeral4.paragraph3"))}
                {returnText(t("termsAdnConditions.numeral4.paragraph4"))}
            </div>

            <div className='w-full flex flex-col gap-[20px]'>
                <h5 className={classSubtitle}>
                    5. {t("termsAdnConditions.numeral5.title")}
                </h5>
                {returnText(t("termsAdnConditions.numeral5.paragraph1"))}
                {returnText(t("termsAdnConditions.numeral5.paragraph2"))}
                {returnText(t("termsAdnConditions.numeral5.paragraph3"))}
            </div>

            <div className='w-full flex flex-col gap-[20px]'>
                <h5 className={classSubtitle}>
                    6. {t("termsAdnConditions.numeral6.title")}
                </h5>
                {returnText(t("termsAdnConditions.numeral6.paragraph1"))}
                {returnTextWithNumber("6.1.", t("termsAdnConditions.numeral6.paragraph2"))}
                {returnTextWithNumber("6.2.", t("termsAdnConditions.numeral6.paragraph3"))}
                {returnTextWithNumber("6.3.", t("termsAdnConditions.numeral6.paragraph4"))}
                {returnTextWithNumber("6.4.", t("termsAdnConditions.numeral6.paragraph5"))}
                {returnTextWithNumber("6.5.", t("termsAdnConditions.numeral6.paragraph6"))}
                {returnTextWithNumber("6.6.", t("termsAdnConditions.numeral6.paragraph7"))}
                {returnTextWithNumber("6.7.", t("termsAdnConditions.numeral6.paragraph8"))}
                {returnTextWithNumber("6.8.", t("termsAdnConditions.numeral6.paragraph9"))}
            </div>

            <div className='w-full flex flex-col gap-[20px]'>
                <h5 className={classSubtitle}>
                    7. {t("termsAdnConditions.numeral7.title")}
                </h5>
                {returnText(t("termsAdnConditions.numeral7.paragraph1"))}
                {returnTextWithNumber("7.1.", t("termsAdnConditions.numeral7.paragraph2"))}
                {returnTextWithNumber("7.2.", t("termsAdnConditions.numeral7.paragraph3"))}
                {returnTextWithNumber("7.3.", t("termsAdnConditions.numeral7.paragraph4"))}
                {returnTextWithNumber("7.4.", t("termsAdnConditions.numeral7.paragraph5"))}
                {returnTextWithNumber("7.5.", t("termsAdnConditions.numeral7.paragraph6"))}
                {returnTextWithNumber("7.6.", t("termsAdnConditions.numeral7.paragraph7"))}
                {returnTextWithNumber("7.7.", t("termsAdnConditions.numeral7.paragraph8"))}
                {returnTextWithNumber("7.8.", t("termsAdnConditions.numeral7.paragraph9"))}
                {returnTextWithNumber("7.9.", t("termsAdnConditions.numeral7.paragraph10"))}
                {returnTextWithNumber("7.10.", t("termsAdnConditions.numeral7.paragraph11"))}
                {returnTextWithNumber("7.11.", t("termsAdnConditions.numeral7.paragraph12"))}
                {returnTextWithNumber("7.12.", t("termsAdnConditions.numeral7.paragraph13"))}
                {returnTextWithNumber("7.13.", t("termsAdnConditions.numeral7.paragraph14"))}
                {returnTextWithNumber("7.14.", t("termsAdnConditions.numeral7.paragraph15"))}
                {returnTextWithNumber("7.15.", t("termsAdnConditions.numeral7.paragraph16"))}
                {returnTextWithNumber("7.16.", t("termsAdnConditions.numeral7.paragraph17"))}
                {returnTextWithNumber("7.17.", t("termsAdnConditions.numeral7.paragraph18"))}
                {returnText(t("termsAdnConditions.numeral7.paragraph19"))}
            </div>

            <div className='w-full flex flex-col gap-[20px]'>
                <h5 className={classSubtitle}>
                    8. {t("termsAdnConditions.numeral8.title")}
                </h5>
                {returnText(t("termsAdnConditions.numeral8.paragraph1"))}
                {returnTextWithNumber("8.1.", t("termsAdnConditions.numeral8.paragraph2"))}
                {returnTextWithNumber("8.2.", t("termsAdnConditions.numeral8.paragraph3"))}
                {returnTextWithNumber("8.3.", t("termsAdnConditions.numeral8.paragraph4"))}
                {returnTextWithNumber("8.4.", t("termsAdnConditions.numeral8.paragraph5"))}
                {returnTextWithNumber("8.5.", t("termsAdnConditions.numeral8.paragraph6"))}
                {returnTextWithNumber("8.6.", t("termsAdnConditions.numeral8.paragraph7"))}
                {returnTextWithNumber("8.7.", t("termsAdnConditions.numeral8.paragraph8"))}
                {returnTextWithNumber("8.8.", t("termsAdnConditions.numeral8.paragraph9"))}
                {returnTextWithNumber("8.9.", t("termsAdnConditions.numeral8.paragraph10"))}
                {returnTextWithNumber("8.10.", t("termsAdnConditions.numeral8.paragraph11"))}
                {returnTextWithNumber("8.11.", t("termsAdnConditions.numeral8.paragraph12"))}
                {returnTextWithNumber("8.12.", t("termsAdnConditions.numeral8.paragraph13"))}
                {returnTextWithNumber("8.13.", t("termsAdnConditions.numeral8.paragraph14"))}
                {returnTextWithNumber("8.14.", t("termsAdnConditions.numeral8.paragraph15"))}
                {returnTextWithNumber("8.15.", t("termsAdnConditions.numeral8.paragraph16"))}
                {returnTextWithNumber("8.16.", t("termsAdnConditions.numeral8.paragraph17"))}
                {returnTextWithNumber("8.17.", t("termsAdnConditions.numeral8.paragraph18"))}
                {returnTextWithNumber("8.18.", t("termsAdnConditions.numeral8.paragraph19"))}
                {returnTextWithNumber("8.19.", t("termsAdnConditions.numeral8.paragraph20"))}
                {returnTextWithNumber("8.20.", t("termsAdnConditions.numeral8.paragraph21"))}
                {returnTextWithNumber("8.21.", t("termsAdnConditions.numeral8.paragraph22"))}
                {returnTextWithNumber("8.22.", t("termsAdnConditions.numeral8.paragraph23"))}
                {returnTextWithNumber("8.23.", t("termsAdnConditions.numeral8.paragraph24"))}
                {returnTextWithNumber("8.24.", t("termsAdnConditions.numeral8.paragraph25"))}
                {returnTextWithNumber("8.25.", t("termsAdnConditions.numeral8.paragraph26"))}
                {returnText(t("termsAdnConditions.numeral8.paragraph27"))}
            </div>

            <div className='w-full flex flex-col gap-[20px]'>
                <h5 className={classSubtitle}>
                    9. {t("termsAdnConditions.numeral9.title")}
                </h5>
                {returnText(t("termsAdnConditions.numeral9.paragraph1"))}
                {returnTextWithNumber("9.1.", t("termsAdnConditions.numeral9.paragraph2"))}
                {returnTextWithNumber("9.2.", t("termsAdnConditions.numeral9.paragraph3"))}
                {returnTextWithNumber("9.3.", t("termsAdnConditions.numeral9.paragraph4"))}
                {returnTextWithNumber("9.4.", t("termsAdnConditions.numeral9.paragraph5"))}
                {returnTextWithNumber("9.5.", t("termsAdnConditions.numeral9.paragraph6"))}
                {returnTextWithNumber("9.6.", t("termsAdnConditions.numeral9.paragraph7"))}
            </div>
        </div >
    )
}

export default TermsAndCondition